  document.addEventListener('DOMContentLoaded', () => {
          function updateOptionMonthly() {
                var options = document.querySelectorAll('#optional-extras input');
                
                // document.querySelector('.summary-options').innerHTML = '';
                var summary = '';
                for (var x = 0; x < options.length; x++) {
                  if (options[x].dataset.price == 0) {
                    options[x].dataset.monthly = 0;
                    options[x].dataset.monthlyVat = 0;
                    options[x].dataset.priceVat = 0;
                  } else {
                    let term, profile, type;

                      type = document.querySelector('#quote-form [name=type]').value;
                      term = document.querySelector('#quote-form [name=term]').value;
                      profile = document.querySelector('#quote-form [name=profile]').value;

                    // console.log(type);
                    // console.log(term);
                    // console.log(profile);
                    options[x].dataset.monthly = (parseFloat(options[x].dataset.price.replace(',', '')) / (parseFloat(profile.replace(',', '')) + (Math.ceil(term.replace(',', '')) - 1))).toFixed(2);
                    options[x].dataset.monthlyVat = (options[x].dataset.monthly * 1.2).toFixed(2);
                    options[x].dataset.priceVat = (options[x].dataset.price * 1.2).toFixed(2);

                  }
                  // Add to Summary
                  if (options[x].dataset.default != 1 && options[x].checked == 1) {
                    summary += '<li>' + options[x].dataset.name + '</li>';
                  }
                }
                if (summary.length > 0) {
                  summary = '<ul>' + summary + '</ul>';
                }
                // document.querySelector('.summary-options').innerHTML = summary;
              }

        updateOptionMonthly();
        // alert(171);
    });

    document.addEventListener('click', function (e) {
        const btn = e.target.closest('.mobile-accordion-header');
        if (!btn) return;

        const panelId = btn.getAttribute('aria-controls');
        if (!panelId) return;

        const panel = document.getElementById(panelId);
        if (!panel) return;

        const isOpen = btn.getAttribute('aria-expanded') === 'true';

        // toggle aria
        btn.setAttribute('aria-expanded', String(!isOpen));

        // toggle panel
        panel.classList.toggle('hidden', isOpen);

        // rotate caret
        const icon = btn.querySelector('.caret-icon');
        if (icon) {
        icon.classList.toggle('rotate-180', !isOpen);
        }



    });

  function updateQueryStringParameter(uri, key, value) {
    var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    var separator = uri.indexOf('?') !== -1 ? "&" : "?";
    if (uri.match(re)) {
      return uri.replace(re, '$1' + key + "=" + value + '$2');
    }
    else {
      return uri + separator + key + "=" + value;
    }
  }



  // OPTION DEPENDENCIES
  let notifications = 0;
  // let delay = alertify.get('notifier','delay');
  // alertify.set('notifier','delay', 4);

  const allRelations = (option_id, checked_arr) => {
    if (relationship_array) {
      for (const [rule_id, rule_options] of Object.entries(relationship_array)) {
        checkRules(rule_options, option_id, rule_id, checked_arr);
      }
    }
  }

  const hasMultipleOptions = (id, rule, checked_arr) => {
    if (relationship_array) {
      for (const [rule_id, rule_options] of Object.entries(relationship_array)) {
        for (const [opt_id, opt] of Object.entries(rule_options)) {
          if (opt.option === id && opt.id !== rule) {
            checkRules(rule_options, id, rule, checked_arr);
          }
        }
      }
    }
  }

  const setZeroPrice = (selector) => {
    if (selector.hasAttribute('data-price') && selector.getAttribute('data-price') != '0') {
      selector.closest('.checkbox-label').querySelector('.option-price').setAttribute('data-text', selector.closest('.checkbox-label').querySelector('.option-price').innerText);
      setTimeout(() => { selector.closest('.checkbox-label').querySelector('.option-price').textContent = 'included'; }, 300)
      selector.setAttribute('data-price-old', selector.dataset.price);
      selector.setAttribute('data-price-vat-old', selector.dataset.priceVat);
      selector.setAttribute('data-monthly-old', selector.dataset.monthly);
      selector.setAttribute('data-monthly-vat-old', selector.dataset.monthlyVat);
      selector.setAttribute('data-price', '0');
      selector.setAttribute('data-price-vat', '0');
      selector.setAttribute('data-monthly', '0');
      selector.setAttribute('data-monthly-vat', '0');
    }
  }
  const restorePrice = (selector) => {
    if (selector.hasAttribute('data-price-old')) {
      selector.closest('.checkbox-label').querySelector('.option-price').textContent = selector.closest('.checkbox-label').querySelector('.option-price').getAttribute('data-text');
      selector.closest('.checkbox-label').querySelector('.option-price').removeAttribute('data-text');
      selector.setAttribute('data-price', selector.dataset.priceOld);
      selector.setAttribute('data-price-vat', selector.dataset.priceVatOld);
      selector.setAttribute('data-monthly', selector.dataset.monthlyOld);
      selector.setAttribute('data-monthly-vat', selector.dataset.monthlyVatOld);
    }
  }
  const optionNameById = (id) => {
    return document.querySelector(`.optional-extras-checkbox[data-option-id='${id}']`).dataset.name;
  }

  const checkRules = (options, option_id, rule_id, checked_arr) => {
    for (const [opt_id, opt] of Object.entries(options)) {
      if(opt.option === option_id && !checked_arr.includes(opt.id)) {
        // console.log(`RULE TRIGGERED: ${opt.type} ${opt.id} TRIGGER: ${option_id}`);
        for (const [opt_id1, opt1] of Object.entries(options)) {
          // console.log(`   OPTION: ${opt1.option} PRIMARY: ${opt1.primary}`);
        }

        if(opt.type === 'OO') {
          // 'OO' - One Of - From the marked options, a maximum of one may be selected.
          for (const [opt_id1, opt1] of Object.entries(options)) {
            if (opt.option !== opt1.option) {
              if (document.querySelector(`.optional-extras-checkbox[data-option-id='${opt.option}']`).checked) {
                if (document.querySelector(`.optional-extras-checkbox[data-option-id='${opt1.option}']`).checked) {
                  document.querySelector(`.optional-extras-checkbox[data-option-id='${opt1.option}']`).checked = false;
                  checked_arr.push(opt.id);
                  notifications++;
                  hasMultipleOptions(opt1.option, rule_id, checked_arr);
                }
              }
            }
          }
        }

        if(opt.type === 'RA') {
          // 'RA' - Requires All - If the primary option is chosen, it is accompanied by all the non primary options in that rule.
          for (const [opt_id1, opt1] of Object.entries(options)) {
            if (opt.option !== opt1.option) {
              if (opt.primary === '1' && document.querySelector(`.optional-extras-checkbox[data-option-id='${opt.option}']`).checked) {
                if (!document.querySelector(`.optional-extras-checkbox[data-option-id='${opt1.option}']`).checked) {
                  document.querySelector(`.optional-extras-checkbox[data-option-id='${opt1.option}']`).checked = true;
                  notifications++;
                  checked_arr.push(opt.id);
                  hasMultipleOptions(opt1.option, rule_id, checked_arr);
                }
              } else if (opt.primary !== '1' && !document.querySelector(`.optional-extras-checkbox[data-option-id='${opt.option}']`).checked) {
                if (document.querySelector(`.optional-extras-checkbox[data-option-id='${opt1.option}']`).checked && opt1.primary === '1') {
                  document.querySelector(`.optional-extras-checkbox[data-option-id='${opt1.option}']`).checked = false;
                  notifications++;
                  checked_arr.push(opt.id);
                  hasMultipleOptions(opt1.option, rule_id, checked_arr);
                }
              }
            }
          }
        }

        if(opt.type === 'NW') {
          // 'NW' - Not With - If the primary option is chosen, none of the other marked options may be chosen.
          for (const [opt_id1, opt1] of Object.entries(options)) {
            if (opt.option !== opt1.option) {
              if (opt.primary === '1' && document.querySelector(`.optional-extras-checkbox[data-option-id='${opt.option}']`).checked) {
                if (document.querySelector(`.optional-extras-checkbox[data-option-id='${opt1.option}']`).checked) {
                  document.querySelector(`.optional-extras-checkbox[data-option-id='${opt1.option}']`).checked = false;
                  notifications++;
                  checked_arr.push(opt.id);
                  hasMultipleOptions(opt1.option, rule_id, checked_arr);
                }
              } else if (opt.primary === '1' && !document.querySelector(`.optional-extras-checkbox[data-option-id='${opt.option}']`).checked) {
                // document.querySelector(`.optional-extras-checkbox[data-option-id='${opt1.option}']`).disabled = false;
                // document.querySelector(`.optional-extras-checkbox[data-option-id='${opt1.option}']`).closest('.checkbox-label').style.opacity = '1'
                if(document.querySelector(`.optional-extras-checkbox[data-option-id='${opt1.option}']`).dataset.default === '1'){
                  document.querySelector(`.optional-extras-checkbox[data-option-id='${opt1.option}']`).checked = true;
                  notifications++;
                  // alertify.success(`<h4>Option Selected: </h4>Default option <em>${optionNameById(opt1.option)}</em> has been automatically selected`);
                  checked_arr.push(opt.id)
                  hasMultipleOptions(opt1.option, rule_id, checked_arr)
                }
              }
              if (opt.primary !== '1' && document.querySelector(`.optional-extras-checkbox[data-option-id='${opt.option}']`).checked) {
                if (opt1.primary === '1' && document.querySelector(`.optional-extras-checkbox[data-option-id='${opt1.option}']`).checked) {
                  document.querySelector(`.optional-extras-checkbox[data-option-id='${opt1.option}']`).checked = false;
                  notifications++;
                  // alertify.error(`<h4>Option Removed: </h4><em>${optionNameById(opt1.option)}</em> cannot be selected alongside <em>${optionNameById(opt.option)}</em> and has been automatically removed`);
                  checked_arr.push(opt.id)
                  hasMultipleOptions(opt1.option, rule_id, checked_arr)
                }
              }
            }
          }
        }

        if(opt.type === 'RO') {
          // 'RO' - Requires One Of - If the primary option is chosen, it must be accompanied by at least one of the non primary options in that rule.
          let allowed = false;
          let required_ids = [];
          for (const [opt_id1, opt1] of Object.entries(options)) {
            if (opt.option !== opt1.option) {
              if (opt.primary === '1' && document.querySelector(`.optional-extras-checkbox[data-option-id='${opt.option}']`).checked) {
                if (document.querySelector(`.optional-extras-checkbox[data-option-id='${opt1.option}']`).checked) {
                  allowed = true;
                } else {
                  required_ids.push(document.querySelector(`.optional-extras-checkbox[data-option-id='${opt1.option}']`).dataset.optionId)
                }
              } else if (opt.primary !== '1' && !document.querySelector(`.optional-extras-checkbox[data-option-id='${opt.option}']`).checked) {
                if (document.querySelector(`.optional-extras-checkbox[data-option-id='${opt1.option}']`).checked && opt1.primary === '1') {
                  document.querySelector(`.optional-extras-checkbox[data-option-id='${opt1.option}']`).checked = false;
                  notifications++;
                  checked_arr.push(opt.id);
                  hasMultipleOptions(opt1.option, rule_id, checked_arr);
                }
              }
            }
          }
          if (opt.primary === '1') {
            if (allowed) {
              notifications++;
              checked_arr.push(opt.id)
              hasMultipleOptions(opt.option, rule_id, checked_arr)
            }
          }
        }

        if(opt.type === 'IN') {
          // 'IN' - Included In - The marked options are included in the price of the primary option, which is a pack.
          for (const [opt_id1, opt1] of Object.entries(options)) {
            if (opt.option !== opt1.option) {
              if (opt.primary === '1' && document.querySelector(`.optional-extras-checkbox[data-option-id='${opt.option}']`).checked) {
                setZeroPrice(document.querySelector(`.optional-extras-checkbox[data-option-id='${opt1.option}']`));
                document.querySelector(`.optional-extras-checkbox[data-option-id='${opt1.option}']`).checked = true;
                notifications++;
                // alertify.success(`<h4>Option Selected: </h4>Option <em>${optionNameById(opt1.option)}</em> has been automatically selected`);
                document.querySelector(`.optional-extras-checkbox[data-option-id='${opt1.option}']`).disabled = true;
                // document.querySelector(`.optional-extras-checkbox[data-option-id='${opt1.option}']`).closest('.checkbox-label').style.opacity = '.3';
                checked_arr.push(opt.id)
                hasMultipleOptions(opt1.option, rule_id, checked_arr)
              } else if (opt.primary === '1' && !document.querySelector(`.optional-extras-checkbox[data-option-id='${opt.option}']`).checked) {
                restorePrice(document.querySelector(`.optional-extras-checkbox[data-option-id='${opt1.option}']`));
                document.querySelector(`.optional-extras-checkbox[data-option-id='${opt1.option}']`).disabled = false;
                notifications++;
                // alertify.error(`<h4>Option Removed: </h4>Option <em>${optionNameById(opt1.option)}</em> has been automatically removed`);
                document.querySelector(`.optional-extras-checkbox[data-option-id='${opt1.option}']`).checked = false;
                // document.querySelector(`.optional-extras-checkbox[data-option-id='${opt1.option}']`).closest('.checkbox-label').style.opacity = '1';
                if(document.querySelector(`.optional-extras-checkbox[data-option-id='${opt1.option}']`).dataset.default === '1'){
                  document.querySelector(`.optional-extras-checkbox[data-option-id='${opt1.option}']`).checked = true;
                  notifications++;
                }
                checked_arr.push(opt.id)
                hasMultipleOptions(opt1.option, rule_id, checked_arr)
              }
            }
            if (opt.primary !== '1' && !document.querySelector(`.optional-extras-checkbox[data-option-id='${opt.option}']`).checked) {
              // alertify.warning(`<h4>Unselected: (IN ${opt.id})</h4><em>${optionNameById(opt1.option)}</em>`);
              restorePrice(document.querySelector(`.optional-extras-checkbox[data-option-id='${opt1.option}']`));
              document.querySelector(`.optional-extras-checkbox[data-option-id='${opt1.option}']`).disabled = false;
              notifications++;
              // alertify.error(`<h4>Option Removed: </h4>Option <em>${optionNameById(opt1.option)}</em> has been automatically removed`);
              document.querySelector(`.optional-extras-checkbox[data-option-id='${opt1.option}']`).checked = false;
              // document.querySelector(`.optional-extras-checkbox[data-option-id='${opt1.option}']`).closest('.checkbox-label').style.opacity = '1';
              if(document.querySelector(`.optional-extras-checkbox[data-option-id='${opt1.option}']`).dataset.default === '1'){
                document.querySelector(`.optional-extras-checkbox[data-option-id='${opt1.option}']`).checked = true;
                notifications++;
                // alertify.success(`<h4>Option Selected: </h4>Default option <em>${optionNameById(opt1.option)}</em> has been automatically selected`);
              }
              checked_arr.push(opt.id)
              hasMultipleOptions(opt1.option, rule_id, checked_arr)
            }
          }
        }

        if(opt.type === 'IO') {
          // 'IO' - Include One Of - If the primary option is chosen, it must be accompanied by one none primary options. The selected none primary option will be included at 0 cost.
          let allowed = false;
          let required_ids = [];
          for (const [opt_id1, opt1] of Object.entries(options)) {
            if (opt.option !== opt1.option) {
              if (opt.primary !== '1' && !document.querySelector(`.optional-extras-checkbox[data-option-id='${opt.option}']`).checked) {
                restorePrice(document.querySelector(`.optional-extras-checkbox[data-option-id='${opt.option}']`));
                document.querySelector(`.optional-extras-checkbox[data-option-id='${opt.option}']`).disabled = false;
                // document.querySelector(`.optional-extras-checkbox[data-option-id='${opt.option}']`).closest('.checkbox-label').style.opacity = '1';
                notifications++;
                // alertify.error(`<h4>Option Removed: </h4>Option <em>${optionNameById(opt.option)}</em> has been automatically removed`);
              }
              if (opt.primary === '1' && document.querySelector(`.optional-extras-checkbox[data-option-id='${opt.option}']`).checked) {
                if (document.querySelector(`.optional-extras-checkbox[data-option-id='${opt1.option}']`).checked) {
                  allowed = true;
                } else {
                  required_ids.push(document.querySelector(`.optional-extras-checkbox[data-option-id='${opt1.option}']`).dataset.optionId)
                }
              } else if (opt.primary !== '1' && !document.querySelector(`.optional-extras-checkbox[data-option-id='${opt.option}']`).checked) {
                restorePrice(document.querySelector(`.optional-extras-checkbox[data-option-id='${opt1.option}']`));
                document.querySelector(`.optional-extras-checkbox[data-option-id='${opt1.option}']`).disabled = false;
                // document.querySelector(`.optional-extras-checkbox[data-option-id='${opt1.option}']`).closest('.checkbox-label').style.opacity = '1';
                if (document.querySelector(`.optional-extras-checkbox[data-option-id='${opt1.option}']`).checked && opt1.primary === '1') {
                  document.querySelector(`.optional-extras-checkbox[data-option-id='${opt1.option}']`).checked = false;
                  notifications++;
                  // alertify.error(`<h4>Option Removed: </h4><em>${optionNameById(opt1.option)}</em> cannot be selected without <em>${optionNameById(opt.option)}</em> and has been automatically removed`);
                  checked_arr.push(opt.id);
                  hasMultipleOptions(opt1.option, rule_id, checked_arr);
                }
              } else if (opt.primary === '1' && !document.querySelector(`.optional-extras-checkbox[data-option-id='${opt.option}']`).checked) {
                restorePrice(document.querySelector(`.optional-extras-checkbox[data-option-id='${opt1.option}']`));
                document.querySelector(`.optional-extras-checkbox[data-option-id='${opt1.option}']`).disabled = false;
                // document.querySelector(`.optional-extras-checkbox[data-option-id='${opt1.option}']`).closest('.checkbox-label').style.opacity = '1';
              }
            }
          }
          if (opt.primary === '1') {
            if (allowed) {
              for (const [opt_id1, opt1] of Object.entries(options)) {
                if (opt1.primary !== '1' && document.querySelector(`.optional-extras-checkbox[data-option-id='${opt1.option}']`).checked) {
                  setZeroPrice(document.querySelector(`.optional-extras-checkbox[data-option-id='${opt1.option}']`));
                  document.querySelector(`.optional-extras-checkbox[data-option-id='${opt1.option}']`).disabled = true;
                  // document.querySelector(`.optional-extras-checkbox[data-option-id='${opt1.option}']`).closest('.checkbox-label').style.opacity = '.3';
                }
              }
              notifications++;
              // alertify.success(`<h4>Option Selected: </h4><em>${optionNameById(opt.option)}</em> has been selected`);
              checked_arr.push(opt.id)
              hasMultipleOptions(opt.option, rule_id, checked_arr)
            } 
          }
        }

      }
    }
  }

  document.querySelectorAll(".optional-extras-checkbox").forEach(value => {
    value.addEventListener("change", () => {
      let checked_arr = [];
      allRelations(value.dataset.optionId, checked_arr);

      checked_arr = [];
    });
  });

  document.querySelectorAll(".optional-extras-checkbox:not([data-paint-uri])").forEach(value => {
    value.addEventListener("change", () => {

      if (notifications > 4) {
        // alertify.dismissAll();
        // alertify.warning(`<h4>Options Updated: </h4><em>Some options were automatically changed.</em>`);
        notifications = 0;
      }

    });
  });


  let quote_terms = document.querySelectorAll('#quote-form .quote-terms');
  for (let i = 0; i < quote_terms.length; i++) {
    quote_terms[i].addEventListener("change", function () {
      updateOptionMonthly();
      loadPrice(); console.log('quote-form 1');
    });
  }

  let hide_options = document.querySelectorAll('.hide-options');
  for (let i = 0; i < hide_options.length; i++) {
    hide_options[i].addEventListener("click", function() {
      document.querySelector('.stock-spec') ? document.querySelector('.stock-spec').classList.remove('hidden') : null;
      document.querySelector('.options-list') ? document.querySelector('.options-list').classList.add('hidden') : null;
      // document.getElementsByName('refundable_fee')[0] ? document.getElementsByName('refundable_fee')[0].value = '0' : null;
    });
    hide_options[i].checked === true ? hide_options[i].dispatchEvent(new Event('click')) : null;
  }

  let show_options = document.querySelectorAll('.show-options');
  for (let i = 0; i < show_options.length; i++) {
    show_options[i].addEventListener("click", function() {
      document.querySelector('.stock-spec') ? document.querySelector('.stock-spec').classList.add('hidden') : null;
      document.querySelector('.options-list') ? document.querySelector('.options-list').classList.remove('hidden') : null;
      // document.getElementsByName('refundable_fee')[0] ? document.getElementsByName('refundable_fee')[0].value = document.querySelector('#quote-form .form-group[data-field="stock"]').dataset.value : null;
    });
    show_options[i].checked === true ? show_options[i].dispatchEvent(new Event('click')) : null;
  }

  let extras = document.querySelectorAll('#optional-extras input');
  for (let i = 0; i < extras.length; i++) {
    extras[i].addEventListener("change", function () {
      updateOptionMonthly();
      loadPrice(); console.log('quote-form 2');
    });
  }


  // }
